import React from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './PdpSharedBlurb.scss';

function PdpSharedBlurb({ Icon, children }) {
    return (
        <div className={styles.wrapper}>
            <div className={styles.icon}>
                <Icon />
            </div>
            <div className={styles.text}>{children}</div>
        </div>
    );
}

PdpSharedBlurb.propTypes = {
    Icon: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default PdpSharedBlurb;
